module.exports = __webpack_public_path__ + "static/img/mediaSlogin.0fd1000d.png";